import clsx from 'clsx';
import type { HTMLAttributes, ReactNode } from 'react';

export type GridColumns = 2 | 3 | 4 | 5 | 6;

const GRID_COLUMN_CLASS: Record<GridColumns, string> = {
    2: 'grid-2-col',
    3: 'grid-3-col',
    4: 'grid-4-col',
    5: 'grid-5-col',
    6: 'grid-6-col',
};

export interface GridProps extends HTMLAttributes<HTMLDivElement> {
    children: ReactNode;
    /** Column count from tablet-up; mobile is always a single column. */
    gridColumns: GridColumns;
    gridClasses?: string;
}

const Grid = ({ children, className, gridColumns, gridClasses, ...props }: GridProps) => {
    return (
        <div className={clsx(GRID_COLUMN_CLASS[gridColumns], className, gridClasses)} {...props}>
            {children}
        </div>
    );
};

export default Grid;
